import './index.css';
import React from 'react';
import classnames from 'classnames';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var styles = {"fill-politico-red":"politico_style___3J_0Tvd2Gj","styles":"politico_style___1ByAqFNLip"};

var Navigation =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Navigation, _React$PureComponent);

  function Navigation() {
    _classCallCheck(this, Navigation);

    return _possibleConstructorReturn(this, _getPrototypeOf(Navigation).apply(this, arguments));
  }

  _createClass(Navigation, [{
    key: "render",
    value: function render() {
      var theme;

      if (this.props.theme) {
        theme = this.props.theme;
      } else if (this.props.site.toLowerCase() === 'magazine') {
        theme = 'dark';
      } else {
        theme = 'light';
      }

      return React.createElement("nav", {
        title: "navigation",
        className: classnames('navigation', 'global', styles.styles)
      }, React.createElement("div", {
        className: classnames({
          magazine: this.props.site.toLowerCase() === 'magazine',
          dark: theme === 'dark',
          light: theme === 'light'
        }),
        id: "global-header"
      }, React.createElement("div", {
        id: "header-contents"
      }, React.createElement("div", {
        id: "global-branding"
      }, this.props.site.toLowerCase() === 'magazine' && React.createElement("a", {
        className: "navbar-brand",
        href: "https://www.politico.com/magazine/",
        title: "POLITICO",
        target: "_top"
      }, React.createElement("span", {
        className: "bt-icon bt-icon--politico"
      }), React.createElement("span", {
        className: "bt-icon bt-icon--magazine"
      })), this.props.site.toLowerCase() !== 'magazine' && React.createElement("a", {
        className: "navbar-brand",
        href: "https://www.politico.com/",
        title: "POLITICO",
        target: "_top"
      }, React.createElement("span", {
        className: "bt-icon bt-icon--politico"
      }))), React.createElement("nav", {
        id: "nav-micro",
        role: "home"
      }, React.createElement("div", {
        className: "header-content"
      }, React.createElement("div", {
        className: "header-left"
      }, React.createElement("a", {
        href: "https://www.politico.com"
      }, React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "20px",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve"
      }, React.createElement("path", {
        d: "M79.5,81.458h-57V41.27L51,16.729L79.5,41.27V81.458z M25.5,78.458h51V42.646L51,20.688L25.5,42.646V78.458z"
      })))), React.createElement("div", {
        className: "header-right"
      }, React.createElement("ul", {
        className: "micro-list"
      }, this.props.site.toLowerCase() !== 'magazine' && React.createElement("li", {
        className: "subnav d-none d-sm-block"
      }, React.createElement("a", {
        href: "https://www.politico.com/magazine/",
        target: "_top"
      }, "Mag", React.createElement("span", {
        className: "d-sm-none d-md-none"
      }, "azine"))), React.createElement("li", {
        className: "subnav d-none d-sm-block"
      }, React.createElement("a", {
        href: "https://www.politico.com/agenda/",
        target: "_top"
      }, React.createElement("span", {
        className: "d-sm-none"
      }, "The"), " Agenda")), React.createElement("li", {
        className: "subnav"
      }, React.createElement("a", {
        href: "https://www.politicopro.com",
        target: "_top"
      }, "PRO")))))))));
    }
  }]);

  return Navigation;
}(React.PureComponent);

Navigation.defaultProps = {
  site: ''
};

export default Navigation;
